import MaintenanceVerification from "../../../maintenance/shared/MaintenanceVerification";

const DisposeVerification = ({data}) => {
    return <MaintenanceVerification data={data} variant="dispose" />;
};

export {DisposeVerification};
